import { useEffect, useState } from 'react'

import { getScreenContent } from 'services/screen-service'

import useFetchData from './useFetchData'
import usePreloadMedia from './usePreloadMedia'

const useScreenContent = (contentTypes, screenId) => {
  const [content, setContent] = useState([])
  const { data: screenContent, refetch } = useFetchData(() => getScreenContent(screenId, contentTypes), [screenId])

  useEffect(() => {
    usePreloadMedia(screenContent)
  }, [screenContent])

  useEffect(() => {
    const contentAttributes = screenContent.data?.[0]

    const mappedContent = contentAttributes
      ? Object.entries(contentAttributes).reduce((prev, [key, value]) => {
          const contentValues =
            value && Array.isArray(value) && value.length > 0
              ? value.map(contentValue => ({ ...contentValue, contentType: key }))
              : []
          return [...prev, ...contentValues]
        }, [])
      : []
    mappedContent.sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt))

    // const orderedContent = contentAttributes?.ContentOrder?.map(contentPiece => {
    //   const contentKeys = Object.keys(contentPiece)
    //   const componentType = contentKeys.filter(key => key !== 'id' && key !== '__component')

    //   return { id: contentPiece[componentType].data[0].id, contentType: componentType.toString() }
    // })

    // const mappedContentOrdered = orderedContent?.reduce((res, { id, contentType }, i, { [i + 1]: next }) => {
    //   const a1 = mappedContent.find(x => x.id === id && x.contentType === contentType)
    //   if (a1) res.push(a1)
    //   if (next) return res
    //   else {
    //     return [
    //       ...res,
    //       mappedContent.filter(r => !res.some(z => z.id === r.id && z.contentType === r.contentType)),
    //     ].flat()
    //   }
    // }, [])

    // const contentToShow = orderedContent?.length > 0 ? mappedContentOrdered : mappedContent

    const contentToShow = mappedContent
    // Give priority to promoted content
    const promotedContent = mappedContent.filter(value => value.promoted === true)
    const visibleContent = promotedContent.length ? promotedContent : contentToShow

    setContent(visibleContent)
  }, [screenContent])

  return { content, refetch }
}

export default useScreenContent
